import { render, staticRenderFns } from "./del.vue?vue&type=template&id=abdd0a1a&scoped=true&"
import script from "./del.vue?vue&type=script&lang=js&"
export * from "./del.vue?vue&type=script&lang=js&"
import style0 from "./del.vue?vue&type=style&index=0&id=abdd0a1a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdd0a1a",
  null
  
)

export default component.exports